import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Menu from "./components/menu"; // Import your menu component
import Home from "./components/home";
import EPDSDataFetcher from "./components/fscCard";
import FscConfigure from "./components/FscConfigure";
import DownloadFscCard from "./components/downloadFsc";
import Footer from "./components/footer";
import Login from "./components/users/login";
import AdminDashboard from "./components/users/admindashboard";
import AgentDashboard from "./components/users/agentdashboard";
import Contact from "./components/contact/Contact";
import FloatingWhatsApp from "./components/contact/FloatingWhatsApp";
import About from "./components/contact/About";
import UserDashboard from "./components/users/UserDashboard";
import Register from "./components/users/Register";
import CompleteProfile from "./components/users/CompleteProfile";
import "./App.css";
import backgroundImage from "./assets/backgroundImageWebsite.png";
import UsersList from "./components/users/UsersList";
// import { useEffect, useState } from "react";
// import { doc, getDoc } from "firebase/firestore";
// import { db } from "./firebase";

const App = () => {
  // const [config, setConfig] = useState(null);

  // useEffect(() => {
  //   const fetchConfig = async () => {
  //     const configRef = doc(db, "admin", "siteSettings");
  //     const configSnap = await getDoc(configRef);
  //     if (configSnap.exists()) {
  //       setConfig(configSnap.data());
  //     }
  //   };
  //   fetchConfig();
  // }, []);

  return (
    <Router>
      <div
        className="d-flex flex-column min-vh-100 full-background"
        // <img src={backgroundImage} alt="bgImage" />
      >
        {/* <div
        style={{ backgroundColor: config?.backgroundColor || "#ffffff" }}
        className="d-flex flex-column min-vh-100"
      > */}
        <Menu />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Menu />} />
          <Route path="/pc-cards" element={<EPDSDataFetcher />} />
          <Route path="/fsc-configur" element={<FscConfigure />} />
          <Route path="/fsc-download" element={<DownloadFscCard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/agent-dashboard" element={<AgentDashboard />} />
          <Route path="/settings" element={<CompleteProfile />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/user-dashboard" element={<UserDashboard />} />
          <Route path="/register" element={<Register />} />
          <Route path="/userlist" element={<UsersList />} />

          {/* <Router path="/contact" element={<Contact />} /> */}
          {/* Add more routes as needed */}
        </Routes>
        <FloatingWhatsApp />
        <Footer />
      </div>
    </Router>
  );
};

export default App;
